var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SqlDatasourceCard',{attrs:{"datasourceId":this.$route.params.id,"dealerId":_vm.dealer.id},on:{"on-save":function($event){return _vm.$router.push({ name: 'sql_datasources_path' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }